import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

class SpogLink extends Component {

    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]).isRequired,
        className: PropTypes.string, // String to set in the class atribute
        disabled:  PropTypes.bool, //if the button is disabled
        external:  PropTypes.bool, //if the href should be an external endpoint
        pathname:  PropTypes.string.isRequired, // The current pathname of the url location
        to:        PropTypes.string, // String to set in href
        onClick:   PropTypes.func // Listener when link was clicked
    };

    static defaultProps = {
        className: '',
        to:        '#',
        disabled:  false,
        external:  false
    };

    componentWillMount() {
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        const {
            to,
            onClick,
            pathname,
            disabled
        } = this.props;

        if (disabled) {
            if (pathname === to || to === '#') {
                e && e.preventDefault && e.preventDefault();
            }
        } else {
            onClick && onClick(e);
        }
    }

    isSameUrl() {
        const {to, history: {location: {pathname}}} = this.props;

        return pathname === to || to === '#';
    }


    render() {
        const {className, children, to, disabled, external} = this.props;

        return to === '#' || external ? <a href={to} disabled={disabled} onClick={this.handleClick} className={className}>{children}</a> :
            <Link disabled={disabled} onClick={this.handleClick} to={to} className={className}>{children}</Link>;
    }
}

export default SpogLink;



// WEBPACK FOOTER //
// ./src/components/ui/element/SpogLink.js